<script setup lang="ts">
import type { StoreProduct, StoreProductCategory } from "@medusajs/types";
import { buildProductBreadcrumbs } from "~/shared/lib/breadcrumbs";

const { data: product_categories } =
  useNuxtData<StoreProductCategory[]>("categories");
const { product } = defineProps<{ product: StoreProduct }>();

const breadcrumbs = computed(() => {
  return buildProductBreadcrumbs(product_categories.value, product);
});
</script>
<template>
  <div class="hidden lg:block my-9">
    <UiBreadcrumbs :items="breadcrumbs" />
  </div>
</template>
